import { Col, Row, Spin } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';
import ActionBar from '../../../../../components/action-bar';
import ActionButton from '../../../../../components/action-button';
import TextItem from '../../../../../components/text-item';
import useLoading from '../../../../../hooks/useLoading';
import { openPopup } from '../../../../../util/window';
import { anexoSelector, fetchAnexo, hasPermissaoSelector } from "../../../../../store/consultivoConsulta";
import { isGestorSelector } from "../../../../../store/autenticacao";
import TextAnexo from "../../../../../components/text-anexo";
import useFormatter from "../../../../../hooks/useFormatter";
import { Consulta } from "../../../../../constants";

export default function ConsultivoConsultaAnexoDetailPage() {
  const { t } = useTranslation();
  const { formatDateTime } = useFormatter();
  const isEditable = useSelector(hasPermissaoSelector(Consulta.Permissoes.ANEXO_ALTERAR.id));
  const anexo = useSelector(anexoSelector);
  const loading = useLoading(fetchAnexo.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const consultaId = match.params.consultaId;
  const id = match.params.id;

  const handleEdit = () => {
    history.replace(`/consultivo/consultas/${consultaId}/anexos/${id}/edit`);
  };

  const handleBack = () => {
    history.replace(`/consultivo/consultas/${consultaId}/anexos`);
  };

  return (
    <Spin spinning={loading}>
      <ActionBar>
        {isEditable && <ActionButton.Edit onClick={handleEdit}/>}
        <ActionButton.Back onClick={handleBack}/>
      </ActionBar>
      <Row gutter={[16, 8]}>
        <Col flex="400px"><TextItem label={t('Nome')}>{anexo?.nome}</TextItem></Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px"><TextAnexo label={t('Anexo')} value={anexo?.anexo}/></Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px"><TextItem label="Criado em">{formatDateTime(anexo?.createdAt)}</TextItem></Col>
        <Col flex="200px"><TextItem label="Alterado em">{formatDateTime(anexo?.updatedAt)}</TextItem></Col>
        <Col flex="200px"><TextItem label="Id">{anexo?.id}</TextItem></Col>
      </Row>
    </Spin>
  );
}
